import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageTitle from '../../../components/PageTitle'
import Loader from '../../../components/Loader'
import Empty from '../../../components/Empty'
import { RequestCard, DetailsModal, Filters } from './components'
import { REQUEST_STATUSES } from '../../../assets/const'
import { getApplications, deleteApplication } from '../../../actions/participant'
import { formatSubmittedAt } from '../../../utils/smallHelpers'




const BACKEND_TO_UI_STATUS = {
  submitted: REQUEST_STATUSES.SUBMITTED,
  accepted: REQUEST_STATUSES.APPROVED,
  rejected: REQUEST_STATUSES.REJECTED,
  withdrawn: REQUEST_STATUSES.WITHDRAWN
}

const Requests = () => {
  const dispatch = useDispatch()
  const applications = useSelector((state) => state.participant.applications.list)
  const loading = useSelector((state) => state.participant.loading)
  const [openId, setOpenId] = useState(null)

  useEffect(() => {
    dispatch(getApplications())
  }, [dispatch])

  const items = useMemo(() => (applications || []).map((a) => ({
    id: a.id,
    title: a.event_name || '',
    location: '',
    dates: '',
    result: 'публикуется после завершения мероприятия',
    submittedAt: formatSubmittedAt(a.submitted_at),
    status: BACKEND_TO_UI_STATUS[a.status],
  })), [applications])


  const handleCancel = useCallback(async () => {
    if (!openId) return
    await dispatch(deleteApplication(openId))
    setOpenId(null)
    dispatch(getApplications())
  }, [dispatch, openId])

  return (
    <section>
      <PageTitle title="Поданные заявки" />
      <Filters />
      {loading ? (
        <Loader size="lg" color="rgb(218 35 41)" />
      ) : items.length === 0 ? (
        <Empty />
      ) : (
        <div className="flex flex-wrap items-start gap-[1.25rem]">
          {items.map((item) => {
            console.log(item)
            return (
              <RequestCard
                key={item.id}
                {...item}
                onDetailsClick={() => setOpenId(item.id)}
              />
            )
          })}
        </div>
      )}

      <DetailsModal
        applicationId={openId}
        onClose={() => setOpenId(null)}
        onCancel={handleCancel}
      />
    </section>
  )
}

export default Requests
